<template>
    <b-container class="m-3">
        <b-row>
            <b-col>
                <p class="h4">
                    <strong>Collections Including Tim Howan</strong>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <div class="d-flex flex-row">
                <Collection/>
                <Collection/>
                <Collection/>
            </div>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
import Collection from './Collection'

export default {
    components: {
        Collection
    },
    data() {
        return {

        }
    }
    
}
</script>